import { render, staticRenderFns } from "./SettingTaxView.vue?vue&type=template&id=168447c3"
import script from "./SettingTaxView.vue?vue&type=script&lang=js"
export * from "./SettingTaxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports